import type { State } from '../reducer.tsx';
import type { AnalyticsDataState } from './reducer.tsx';

export const get = (state: State): AnalyticsDataState => state.analyticsData;
